var _rect, _path, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#EB3A56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 42.8V22.5752C46.4 21.2557 45.8758 19.9902 44.9428 19.0572C44.0098 18.1242 42.7443 17.6 41.4248 17.6H21.2C21.2048 16.6436 21.588 15.7279 22.266 15.0533C22.944 14.3787 23.8616 14 24.818 14H43.6694C45.3483 14.0014 46.9579 14.6691 48.1449 15.8564C49.3318 17.0437 49.999 18.6535 50 20.3324V39.182C50 40.1384 49.6213 41.056 48.9467 41.734C48.2721 42.412 47.3564 42.7952 46.4 42.8ZM39.182 21.2H17.618C15.62 21.2 14 22.82 14 24.818V46.382C14 48.38 15.62 50 17.618 50H39.182C41.18 50 42.8 48.38 42.8 46.382V24.818C42.8 22.82 41.18 21.2 39.182 21.2ZM23 37.85L26.8574 42.3644L32.2574 35.6L38.237 43.3508C38.3261 43.4654 38.3812 43.6027 38.396 43.7471C38.4108 43.8914 38.3847 44.0371 38.3207 44.1673C38.2567 44.2976 38.1574 44.4072 38.034 44.4837C37.9107 44.5603 37.7683 44.6005 37.6232 44.6H19.2128C19.0665 44.6005 18.9231 44.5595 18.7992 44.4817C18.6753 44.404 18.5759 44.2928 18.5126 44.1609C18.4493 44.0291 18.4247 43.882 18.4416 43.7367C18.4584 43.5914 18.5162 43.4538 18.608 43.34L23 37.85Z",
    fill: "#FEFEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.10532,
    y: 9.86737,
    width: 7.18746,
    height: 66.2492,
    rx: 3.59373,
    transform: "rotate(-45.3564 7.10532 9.86737)",
    fill: "#EB3A56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.80588,
    y: 14.7,
    width: 5.59715,
    height: 58.3397,
    rx: 2.79858,
    transform: "rotate(-45.3564 6.80588 14.7)",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.9c5a5c111f5791ba60a8eb51746ebb3f.svg";
export { ForwardRef as ReactComponent };